import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { reducers, metaReducers } from './index';
import { environment } from 'src/environments/environment';
import { EffectsModule } from '@ngrx/effects';
import * as fromApp from './app/app.reducer';
import * as fromInfluencer from './influencers/influencers.reducer';

import { AppEffects } from './app/app.effects';
import { InfluencersEffects } from './influencers/influencers.effects';
import { AuthenticationStoreModule } from './auth/authentication-store.module';


@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    !environment.production
      ? StoreDevtoolsModule.instrument({
        name: 'PAX',
        logOnly: environment.production
      })
      : [],
    EffectsModule.forRoot([]),
    AuthenticationStoreModule,
    StoreModule.forFeature(fromApp.appKey, fromApp.reducer),
    StoreModule.forFeature(fromInfluencer.influencerKey, fromInfluencer.reducer),
    EffectsModule.forFeature([AppEffects, InfluencersEffects]),
  ],
  exports: [StoreModule]
})
export class AppStoreModule { }
